export enum CartRecommendationType {
  SCORE_MATRIX = 'score_matrix',
}
